export default __webpack_public_path__ + "static/media/Dr. Minakshi Panda.f2817e08.png";